import MeasurementsContainer from './containers/MeasurementsContainer';

export default MeasurementsContainer;
